import format from 'string-template';

import BaseDocument from '../../Model/BaseDocument';
import { firestorePaths, pathPlaceholder } from '../../utils/paths';

/**
 * Class representing a user's interaction with an announcement comment.
 *
 * @class AnnouncementCommentInteraction
 * @extends BaseDocument
 */
class AnnouncementCommentInteraction extends BaseDocument {
  /**
   * Creates an announcement comment interaction document reference.
   *
   * @param {string} userId - The ID of the user interacting with the comment.
   * @param {string} announcementId - The ID of the parent announcement.
   * @param {string} commentId - The ID of the parent announcement comment.
   * @param {Object} opts - Firestorter/BaseDocument options.
   */
  constructor(userId, announcementId, commentId, opts) {
    super(
      `${format(firestorePaths.ANNOUNCEMENT_COMMENT_INTERACTION, {
        [pathPlaceholder.ANNOUNCEMENT_ID]: announcementId,
        [pathPlaceholder.ANNOUNCEMENT_COMMENT_ID]: commentId,
      })}/${userId}`,
      opts,
    );
  }

  /**
   * Whether the comment is liked by the user.
   * @returns {boolean}
   */
  get liked() {
    return !!this.data.liked;
  }
}

export default AnnouncementCommentInteraction;
